import { MenuItemsType, DropdownMenuItemType, menuStatus } from 'vvs-uikit'
import { ContextApi } from 'contexts/Localization/types'
import { isBlindMode } from 'utils'
import { Path } from 'config/constants/paths'
import { VVS_GOTCHI_MAINTENANCE_MODE } from 'config/constants/vvsgotchi'
import { isVvsMinerMolePhase1, isVvsMinerMolePhase2, isVvsMinerMolePhase4BlindBoxReveal } from 'config/constants/env'
import { getVVSMinerMoleMintedUrl } from 'utils/mintedNftCollectionUrls'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean; home?: boolean }
export const getVvsMinerMoleMenuConfig: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Gallery'),
    href: Path.VVS_MINER_MOLE_GALLERY,
    status: isVvsMinerMolePhase4BlindBoxReveal ? undefined : menuStatus.SOON_V2,
    disabled: !isVvsMinerMolePhase4BlindBoxReveal,
  },
  {
    label: t('Rarity'),
    href: `${Path.VVS_MINER_MOLE}#rarity`,
    type: DropdownMenuItemType.ANCHOR,
  },
  {
    label: t('Roadmap'),
    href: `${Path.VVS_MINER_MOLE}#roadmap`,
    type: DropdownMenuItemType.ANCHOR,
  },
  {
    label: t('FAQ'),
    href: `${Path.VVS_MINER_MOLE}#faq`,
    type: DropdownMenuItemType.ANCHOR,
  },
  {
    label: t('My Moles'),
    href: `${Path.VVS_MINER_MOLE_MY_MOLES}`,
    disabled: isVvsMinerMolePhase1,
  },
  {
    label: '',
    href: '/',
    icon: 'More',
    hideSubNav: true,
    items: [
      {
        label: t('Marketplace'),
        href: getVVSMinerMoleMintedUrl(),
        type: DropdownMenuItemType.EXTERNAL_LINK,
        showItemsOnMobile: true,
        status: isVvsMinerMolePhase2 ? undefined : menuStatus.SOON_V2,
        disabled: !isVvsMinerMolePhase2,
        anchorTarget: '_blank',
      },
      {
        label: t('VVS Finance'),
        href: `${window.location.origin}/`, // workaround https://mcoproduct.atlassian.net/browse/VVS-996
        type: DropdownMenuItemType.EXTERNAL_LINK,
        showItemsOnMobile: true,
        anchorTarget: '_self',
      },
      {
        label: VVS_GOTCHI_MAINTENANCE_MODE ? t('VVSGotchi ( 🚧 Maintenance)') : t('VVSGotchi'),
        disabled: VVS_GOTCHI_MAINTENANCE_MODE,
        href: Path.VVS_GOTCHI,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        showItemsOnMobile: true,
        anchorTarget: '_self',
      },
    ],
  },
]
export const getMenuConfig: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    items: [
      {
        label: t('Swap'),
        href: '/swap',
      },
      {
        label: t('Liquidity'),
        href: '/liquidity',
      },
      {
        label: t('Flash LP'),
        href: '/zap',
      },
      {
        label: t('Limit Orders'),
        href: '/limit-orders',
      },
      {
        label: t('Perpetuals'),
        href: process.env.REACT_APP_FULCROM_URL || 'https://perps.vvs.finance/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    icon: 'Earn',
    items: [
      {
        label: t('Farms'),
        href: '/farms',
      },
      {
        label: t('Mines'),
        href: '/mines',
      },
      {
        label: t('xVVS'),
        href: '/xvvs',
      },
      {
        label: t('Boost Calculator'),
        href: Path.BOOST_CALCULATOR,
      },
    ],
  },
  {
    label: t('Dashboard'),
    href: '/dashboard',
    icon: 'Dashboard',
    showItemsOnMobile: false,
  },
  {
    label: t('IGO'),
    href: '/igo',
    icon: 'IGO',
    showItemsOnMobile: false,
    hidden: isBlindMode(),
  },
  {
    label: '',
    href: '/',
    icon: 'More',
    hideSubNav: true,
    items: [
      {
        label: t('VVS Miner Moles'),
        href: `${window.location.origin}${Path.VVS_MINER_MOLE}`,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        anchorTarget: '_self',
      },
      {
        label: VVS_GOTCHI_MAINTENANCE_MODE ? t('VVSGotchi ( 🚧 Maintenance)') : t('VVSGotchi'),
        disabled: VVS_GOTCHI_MAINTENANCE_MODE,
        href: `${window.location.origin}${Path.VVS_GOTCHI}`,
        type: DropdownMenuItemType.EXTERNAL_LINK,
        anchorTarget: '_self',
      },
      {
        label: t('Analytics'),
        href: '/info',
        type: DropdownMenuItemType.INTERNAL_LINK,
      },
      {
        label: t('Docs'),
        href: 'https://docs.vvs.finance',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Code'),
        href: 'https://github.com/vvs-finance',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Community'),
        href: '/',
        type: DropdownMenuItemType.INTERNAL_LINK,
        onClick: () => {
          setTimeout(() => {
            document.querySelector('#Community')?.scrollIntoView()
          }, 200)
        },
      },
    ],
  },
]

export default getMenuConfig
